var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3132 8.17893C10.8066 8.7162 10.4998 9.56047 10.4998 10.635V49.3331C10.4998 50.423 10.8066 51.2519 11.3132 51.7892L11.4361 51.912L33.1107 30.2374V29.7308L11.4361 8.05615L11.3132 8.17893Z",
    fill: "#5BBAE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3562 37.4826L33.1262 30.2525V29.746L40.3562 22.516L40.525 22.6081L49.0906 27.4741C51.5313 28.871 51.5313 31.1429 49.0906 32.5244L40.525 37.3904L40.3562 37.4826Z",
    fill: "url(#paint0_linear_637_15323)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.525 37.3906L33.1415 29.9918L11.3286 51.8046C12.1422 52.6642 13.4623 52.7563 14.9666 51.9121L40.525 37.3906Z",
    fill: "url(#paint1_linear_637_15323)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.525 22.6088L14.9666 8.08741C13.4623 7.24315 12.1422 7.33526 11.3286 8.19488L33.1415 30.0077L40.525 22.6088Z",
    fill: "url(#paint2_linear_637_15323)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_637_15323",
    x1: 47.4942,
    y1: 29.9916,
    x2: 5.14253,
    y2: 29.9916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ECAD0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EA9418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_637_15323",
    x1: 36.5032,
    y1: 34.0136,
    x2: -3.31555,
    y2: 73.8324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7166C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_637_15323",
    x1: -3.49981,
    y1: -14.0324,
    x2: 29.0122,
    y2: 18.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26906F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2B926E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#52A46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6BAE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B368"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.8254a68790a730a227dcc843b760c11f.svg";
export { ForwardRef as ReactComponent };